import React from 'react';
import { Search, X } from 'lucide-react';
import Can from '../Common/Can';
import { P } from '../../constants/permissions';
import { LICENSE_STATUS_OPTIONS } from '../../utils/licenseListFilters';

const LicenseFilters = ({ filters, search, tipoOptions = [] }) => {
  const typeOptions = [{ value: '', label: 'Todos os tipos' }, ...tipoOptions];

  return (
    <div className="card">
      <div className="card-content">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
          <div className="form-group">
            <label className="form-label">Status</label>
            <select
              className="form-select"
              value={filters.filters.status}
              onChange={(e) => filters.updateFilter('status', e.target.value)}
            >
              {LICENSE_STATUS_OPTIONS.map((option) => (
                <option key={option.value || 'all'} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">Tipo de Licença</label>
            <select
              className="form-select"
              value={filters.filters.type}
              onChange={(e) => filters.updateFilter('type', e.target.value)}
            >
              {typeOptions.map((option) => (
                <option key={option.value || 'all-types'} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">Empreendimento</label>
            <input
              type="text"
              className="form-input"
              placeholder="Nome do empreendimento"
              value={filters.filters.enterprise}
              onChange={(e) => filters.updateFilter('enterprise', e.target.value)}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Vence até</label>
            <input
              type="date"
              className="form-input"
              value={filters.filters.dateTo}
              onChange={(e) => filters.updateFilter('dateTo', e.target.value)}
            />
          </div>
        </div>

        <div className="flex items-center justify-between">
          <Can permission={P.LICENSES_PAGE}>
            <button
              type="button"
              onClick={filters.clearFilters}
              className="btn btn-outline btn-sm"
            >
              <X className="w-4 h-4 mr-1" />
              Limpar
            </button>
          </Can>

          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
            <input
              type="text"
              placeholder="Buscar licenças..."
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
              value={search.query}
              onChange={(e) => search.search(e.target.value)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LicenseFilters;
